/**
 * Shared entry option lists + pH dial thresholds.
 *
 * The authoritative slot × param matrix, validation tiers, pH dial, and
 * completion logic live in `@/lib/waterModel`.
 */

/** The Settings page cards for browser push and notification preferences; off until notifications are rolled out to farms. */
export const SHOW_NOTIFICATION_SETTINGS = false;

/**
 * Water color options for dropdown
 */
export const WATER_COLOR_OPTIONS = [
  { value: 'green', label: 'Green' },
  { value: 'light_green', label: 'Light Green' },
  { value: 'dark_green', label: 'Dark Green' },
  { value: 'blue', label: 'Blue' },
  { value: 'brown', label: 'Brown' },
  { value: 'light_brown', label: 'Light Brown' },
  { value: 'dark_brown', label: 'Dark Brown' },
  { value: 'red_brown', label: 'Red Brown' },
  { value: 'red', label: 'Red' },
  { value: 'yellowish', label: 'Yellowish' },
  { value: 'milky', label: 'Milky' },
  // Not plain "Clear": on the phone water screen it sits beside the keypad's Clear button.
  { value: 'clear', label: 'Clear water' },
  { value: 'turbid', label: 'Turbid' },
];

/**
 * Weather options for dropdown
 */
export const WEATHER_OPTIONS = [
  { value: 'sunny', label: 'Sunny' },
  { value: 'partly_cloudy', label: 'Partly Cloudy' },
  { value: 'cloudy', label: 'Cloudy' },
  { value: 'overcast', label: 'Overcast' },
  { value: 'light_rain', label: 'Light Rain' },
  { value: 'rain', label: 'Rain' },
  { value: 'heavy_rain', label: 'Heavy Rain' },
  { value: 'storm', label: 'Storm' },
];

/**
 * Cal/Mag status options
 */
export const CAL_MAG_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'low', label: 'Low' },
  { value: 'high', label: 'High' },
];

/**
 * pH Dial thresholds (3pm − 7am difference). Warn when |Δ| > 0.3.
 */
export const PH_DIAL_THRESHOLDS = {
  ok: 0.3, // <= 0.3 is good
  warning: 0.5, // 0.3-0.5 is warning; > 0.5 critical
};
